import { Textarea, type TextareaProps } from '@ctct/summit-core';
import { useFormContext } from 'react-hook-form';

import { type InputOpts } from '../../types';
import { getDisableAutofillProps } from '../../utils';

const TextareaInput = ({
  formKey,
  registerOpts,
  onChange,
  shouldDisableAutofill = false,
  ...inputProps
}: InputOpts
  & TextareaProps & {
    shouldDisableAutofill?: boolean;
  }) => {
  const { register } = useFormContext();
  const { onChange: registeredOnChange, ...restRegisterOpts } = register(formKey, registerOpts);

  const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    registeredOnChange(event);
    onChange?.(event);
  };
  return (
    <Textarea
      {...getDisableAutofillProps(shouldDisableAutofill)}
      {...restRegisterOpts}
      {...inputProps}
      onChange={handleOnChange}
    />
  );
};

export { TextareaInput };
